<template>
  <div>
    <div>
      <!-- 使用组件 -->
      <MemberInfo></MemberInfo>
    </div>
    <div class="header-centers">
      <div>
        <el-card class="NumberCardWidth">
          <div class="deal flex-between">
            <div class="card-text">
              <h3>会员地址</h3>
            </div>
            <div class="card-button">
              <el-button
                class="push-button"
                @click="NvagetToLookMenber"
                icon="iconfont icon-fanhui"
                >返回基本信息</el-button
              >
            </div>
          </div>
          <div class="NumberTable">
            <!-- table列表 -->
            <Table
              @TouchTheBottom="TouchTheBottom"
              :PagesData="paging"
              :tableData="list.tbody"
              :configTable="list.thead"
              :config="list"
            ></Table>
          </div>
        </el-card>
      </div>
      <!-- 右侧列表相关链接 -->
      <!-- 使用封装的组件 -->
      <div class="PagesContentRight">
        <RightCard></RightCard>
      </div>
    </div>
  </div>
</template>

<script>
import { GetCustRecvAddress } from "@/api/viewMemberModule";
import Table from "/src/components/NumberTable/index.vue";
import { getcpyNo } from "@/utils/auth";
import { mapState } from "vuex";
export default {
  name: "centre",
  components: {
    Table: Table,
  },
  data() {
    return {
      paging: {
        page: 1,
        size: 50,
        total: 0,
        pages: 2,
        Loading: true,
      },
      list: {
        thead: [
          //设置表头
          {
            label: "",
            prop: "CopyIndex",
            width: 50,
          },
          {
            label: "状态",
            prop: "state",
            width: 80,
          },
          {
            label: "省份",
            prop: "province",
            width: 100,
          },
          {
            label: "城市",
            prop: "city",
            width: 100,
          },
          {
            label: "区域",
            prop: "area",
            width: 100,
          },
          {
            label: "详细地址",
            prop: "address",
            width: 200,
          },
          {
            label: "收货人",
            prop: "receiver",
            width: 80,
          },
          {
            label: "收货人手机号",
            prop: "phone",
            width: 150,
          },
          {
            label: "是否默认地址",
            prop: "isDefaultAddress",
            width: 150,
          },
          {
            label: "创建时间",
            prop: "createTime",
            width: 160,
          },
          {
            label: "最后修改时间",
            prop: "updateTime",
            width: 160,
          },
        ],
        tbody: [],
      },
    };
  },
  computed: {
    ...mapState({
      custID: (state) => state.user.custID,
    }),
  },
  created() {
    this.RGetCustRecvAddress();
  },
  methods: {
    RGetCustRecvAddress() {
      let data = require("qs").stringify({
        cpyNo: getcpyNo,
        custID: this.custID,
        pageSize: this.paging.size,
        pageNo: this.paging.page,
      });
      GetCustRecvAddress(data).then((res) => {
        if (res.success) {
          if (res.data.list.length > 0) {
            this.paging.total = res.data.total;
            this.paging.pages = res.data.pages;
            console.log(res)
            res.data.list.forEach((item, index) => {
              item.CopyIndex =
                (this.paging.page - 1) * this.paging.size + index + 1;
              item.isDefaultAddress =
                item.isDefaultAddress == true ? "是" : "否";
              item.state =
                parseInt(item.state) == 0
                  ? "有效"
                  : parseInt(item.state) == 1
                  ? "无效"
                  : "";
              item.createTime = this.renderTime(item.createTime);
              item.updateTime = this.renderTime(item.updateTime);
            });
            this.list.tbody = this.list.tbody.concat(res.data.list);
            console.log(res.data.list)
          }else{
            this.paging.pages=0
          }
        } else {
          this.$message.error(res.message);
        }
         this.paging.Loading = false;
      });
    },
    renderTime(date) {
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
    TouchTheBottom() {
      this.paging.page++;
      this.RGetCustRecvAddress();
    },
    NvagetToLookMenber() {
      this.$router.push("/LookMember");
    },
  },
};
</script>
<style lang="scss" scoped>
.NumberCardWidth {
  width: 1265px;
}
.header-centers {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
}
.PagesContentRight {
  margin-left: 25px;
  height: 990px;
  display: flex;
  flex-direction: column;
  justify-self: flex-start;
  align-content: flex-start;
}
.NumberTable {
  margin-top: 40px;
}
.card-text {
  color: #a19b5a;
}
.push-button {
  background-color: #e9e7d3;
  border-radius: 7px;
  color: #a19b59;
}
</style>
